import React, { FunctionComponent, useEffect, useRef, useState } from "react";
import { connect, useDispatch } from "react-redux";
import styles from "./BrowseContacts.module.css";
import { motion, AnimatePresence } from "framer-motion";
import { IoIosClose } from "react-icons/io";
import { themeColors } from "../../theme";
import Dropdown from "../../DropDown/Dropdown";
import DateInput from "../../DateInput/DateInput";
import CustomButton from "../Button/CustomButton";
import moment from "moment";
import { getUniqueLeadCount } from "../../../Services/marketingAutomation";
import makeAnimated from "react-select/animated";
import {
  setBrowseContactBudgetFrom,
  setBrowseContactBudgetTo,
  setBrowseContactFronDate,
  setBrowseContactLeadAssignee,
  setBrowseContactLeadSource,
  setBrowseContactLeadType,
  setBrowseContactProjectName,
  setBrowseContactPropertyType,
  setBrowseContactRequirementType,
  setBrowseContactToDate,
  showSnackbarAction,
} from "../../../Redux/actions";
import Select from "react-select";
import Backdrop from "../../Backdrop/Backdrop";
import axiosHandler from "../../../Services/axiosHandler";
import { requirementTypeBudgetRange, salesBudgetRange, url } from "../../../Values/constants";

type props = {
  close: () => void;
  open: boolean;
  theme?: any;
  user?: any;
  analyticsFilter?: any;
  setbrowseContactDetail: (value: any) => void;
  camType: any;
  setTotalReciptent?: any;
  browseContactDetail: any;
  browseContactData: any;
};

const slideInFromRight = {
  hidden: {
    translateX: "0%", // Move off-screen to the right, without affecting layout
    opacity: 0,
  },
  visible: {
    translateX: "0%", // Bring into view
    opacity: 1,
    transition: {
      duration: 0.25,
      ease: "linear",
    },
  },
  exit: {
    translateX: "0%", // Slide out without triggering horizontal scrollbars
    opacity: 0,
    transition: {
      duration: 0.25,
      ease: "linear",
    },
  },
};

const BrowseContacts: FunctionComponent<props> = ({
  close,
  open,
  theme,
  user,
  analyticsFilter,
  setbrowseContactDetail,
  camType,
  setTotalReciptent,
  browseContactDetail,
  browseContactData,
}) => {
  const [filterValue, setFilterValue] = useState<any>();
  const [apiFilterValue, setApiFilterValue] = useState<any>();
  const [projectDropdownName, setProjectDropdownName] = useState<any>([]);
  const [propertyTypeDropdown, setPropertyTypeDropdown] = useState<any>([]);
  const [budgetToDropdown, setBudgetToDropdown] = useState<any>([]);
  const [BudgetRange, setBudgetRange] = useState<any>([]);
  const [leadTypeDropdown, setLeadTypeDropdown] = useState<any>([
    "Data",
    "Leads",
  ]);
  const [leadSourceDropdown, setLeadSourceDropdown] = useState<any>([]);
  const [leadAssigneDropdown, setLeadAssigneDropdown] = useState<any>([]);

  const [selectedFromDate, setSelectedFromDate] = useState<any>(browseContactData?.fromDate?browseContactData?.fromDate:"");
  const [selectedToDate, setSelectedToDate] = useState<any>(browseContactData?.toDate?browseContactData.toDate:"");
  const [selectedProjectName, setSelectedProjectName] = useState<any>(browseContactData?.projectNameSelected?browseContactData.projectNameSelected:[]);
  const [selectedPropertyType, setSelectedPropertyType] = useState<any>(browseContactData?.propertyTypeSelected?browseContactData.propertyTypeSelected:[]);
  const [selectedRequirementType, setSelectedRequirementType] = useState<any>(browseContactData?.requirementTypeSelected?browseContactData?.requirementTypeSelected:[]);
  const [selectedBudgetFrom, setSelectedBudgetFrom] = useState<any>(browseContactData?.budgetFromSelected?browseContactData.budgetFromSelected:[]);
  const [selectedBudgetTo, setSelectedBudgetTo] = useState<any>(browseContactData?.budgetToSelected?browseContactData.budgetToSelected:[]);
  const [selectedLeadSource, setSelectedLeadSource] = useState<any>(browseContactData?.leadSourceSelected?browseContactData.leadSourceSelected:[]);
  const [selectedLeadType, setSelectedLeadType] = useState<any>(browseContactData?.leadTypeSelected?browseContactData.leadTypeSelected:[]);
  const [selectedLeadAssignee, setSelectedLeadAssignee] = useState<any>(browseContactData?.leadAssigneeSelected?browseContactData.leadAssigneeSelected:[]);

  const animatedComponents = makeAnimated();

  useEffect(()=>{
    if(browseContactData?.requirementTypeSelected?.label === "RENTAL"){
      setBudgetRange(requirementTypeBudgetRange)
    }else{
      setBudgetRange(salesBudgetRange)
    }
  },[browseContactData?.requirementTypeSelected])

  useEffect(() => {
    const filteredOptions = BudgetRange.filter(
      (budget:any) =>
        parseInt(budget.value) >
        parseInt(selectedBudgetFrom?.value)
    );
    if (filteredOptions?.length === 0) {
      setBudgetToDropdown(selectedRequirementType?.label === "RENTAL"?[{ value: "5100000", label: "Max" }]:[{ value: "1000000000", label: "Max" }]);
    } else {
      setBudgetToDropdown(selectedRequirementType?.label === "RENTAL"?[{ value: "5100000", label: "Max" },...filteredOptions]:[{ value: "1000000000", label: "Max" },...filteredOptions]);
      // setBudgetToDropdown(filteredOptions);
    }
  }, [selectedBudgetFrom]);

  useEffect(() => {
    // setFilterValue(analyticsFilter);
    if (apiFilterValue?.project) {
      const cleanedData = apiFilterValue?.project.filter(
        (item: string) => item.trim() !== ""
      );
      setProjectDropdownName(cleanedData);
    }
    if (apiFilterValue?.property_type) {
      const cleanedData = apiFilterValue?.property_type.filter(
        (item: string) => item.trim() !== ""
      );
      setPropertyTypeDropdown(cleanedData);
    }
    if (apiFilterValue?.lead_source) {
      const cleanedData = apiFilterValue?.lead_source.filter(
        (item: string) => item.trim() !== ""
      );
      setLeadSourceDropdown(cleanedData);
    }
    if (apiFilterValue?.contact_owner_email) {
      const cleanedData = apiFilterValue?.contact_owner_email.filter(
        (item: string) => item.trim() !== ""
      );
      setLeadAssigneDropdown(cleanedData);
    }
  }, [analyticsFilter, apiFilterValue]);
  const dispatcher = useDispatch();

  const getContactsFilter = async () => {
    const res = await axiosHandler.post(url + "/leads/filterValues", {
      // uid: user.uid,
    });
    setApiFilterValue(res.data[0]);
  };

  useEffect(() => {
    if (user) {
      getContactsFilter();
    }
  }, [user]);

  const onSubmit = async () => {
    if (
      selectedFromDate === "" &&
      selectedToDate === "" &&
      selectedProjectName?.length === 0 &&
      selectedPropertyType?.length === 0 &&
      selectedRequirementType?.length === 0 &&
      selectedBudgetFrom?.length === 0 &&
      selectedBudgetTo?.length === 0 &&
      selectedLeadSource?.length === 0 &&
      selectedLeadType?.length === 0 &&
      selectedLeadAssignee?.length === 0
    ) {
      dispatcher(showSnackbarAction("Please select a value", "error"));
      return;
    } else if (
      (selectedFromDate !== "" &&
        selectedToDate === "") ||
      (selectedFromDate === "" && selectedToDate !== "")
    ) {
      // Logic runs only if one date is selected
      dispatcher(showSnackbarAction("Please Select Both Date", "error"));
      return;
    } 
    else if(selectedBudgetFrom?.length !== 0 && selectedBudgetTo?.length === 0){
      dispatcher(showSnackbarAction("Please Select Budget", "error"));
      return;
    }
    else {
      let created_at: any = undefined;
      if (
        selectedFromDate !== "" &&
        selectedToDate !== ""
      ) {
        let startDate = moment(selectedFromDate).startOf("day").toDate();
        let endDate = moment(selectedToDate).endOf("day").toDate();
        created_at = [startDate.toISOString(), endDate.toISOString()];
      }
      let projectName: any = [];
      let propertyType: any = [];
      let Budget: any = [selectedBudgetFrom?.value,selectedBudgetTo?.value];
      let leadSource: any = [];
      let leadType: any = [];
      let leadAssigne: any = [];
      if (selectedProjectName?.length !== 0) {
        selectedProjectName?.forEach((element: any) => {
          projectName.push(element.value);
        });
      }
      if (selectedPropertyType?.length !== 0) {
        selectedPropertyType?.forEach((element: any) => {
          propertyType.push(element.value);
        });
      }
      if (selectedLeadSource?.length !== 0) {
        selectedLeadSource?.forEach((element: any) => {
          leadSource.push(element.value);
        });
      }
      if (selectedLeadType?.length !== 0) {
        selectedLeadType?.forEach((element: any) => {
          leadType.push(element.value);
        });
      }
      if (selectedLeadAssignee?.length !== 0) {
        selectedLeadAssignee?.forEach((element: any) => {
          leadAssigne.push(element.value);
        });
      }

      const uniqueLeadCount = await getUniqueLeadCount(
        created_at,
        projectName,
        propertyType,
        [selectedBudgetFrom?.value,selectedBudgetTo?.value],
        leadSource,
        leadType,
        leadAssigne,
        selectedRequirementType?.value,
        user
      );
      if (uniqueLeadCount === 0 || uniqueLeadCount === undefined) {
        dispatcher(showSnackbarAction("No recipient data found", "error"));
        // setTotalReciptent("");
        return;
      } else {
        dispatcher(setBrowseContactFronDate(selectedFromDate));
        dispatcher(setBrowseContactToDate(selectedToDate));
        dispatcher(setBrowseContactLeadAssignee(selectedLeadAssignee));
        dispatcher(setBrowseContactLeadType(selectedLeadType));
        dispatcher(setBrowseContactLeadSource(selectedLeadSource));
        dispatcher(setBrowseContactRequirementType(selectedRequirementType));
        dispatcher(setBrowseContactProjectName(selectedProjectName));
        dispatcher(setBrowseContactPropertyType(selectedPropertyType));
        dispatcher(setBrowseContactBudgetTo(selectedToDate));
        dispatcher(setBrowseContactBudgetFrom(selectedFromDate));

        setbrowseContactDetail({
          created_at: created_at,
          project_name: projectName,
          property_type: propertyType,
          budget: Budget,
          lead_source: leadSource,
          lead_type: leadType,
          lead_assigne: leadAssigne,
          requirement_type:selectedRequirementType?.value
        });
        setTotalReciptent(uniqueLeadCount ? uniqueLeadCount : "");
        camType("Contacts");
        close();
      }
    }
  };

  return (
    <>
      {/* {load === true && <Loading />} */}
      <AnimatePresence>
        {open && (
          <Backdrop>
            <motion.div
              key="modal"
              className="shadow"
              style={{
                position: "absolute",
                top: 0,
                right: 0,
                width: "35vw",
                height: "100vh",
                display: "flex",
                flexDirection: "column",
                boxShadow: "0 3px 11px 0 rgba(0, 0, 0, 0.2)",
                zIndex: 1000,
                overflowX: "hidden",
                // gap: "1rem",
                // justifyContent: "center",
                // alignItems: "center",
                // ...containerStyles
                backgroundColor: "#fff",
              }}
              variants={slideInFromRight}
              initial="hidden"
              animate="visible"
              exit="exit"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  padding: "1rem",
                  gap: "0.5rem",
                }}
              >
                <div className={styles.titleDiv}>
                  <p className={styles.title}>SELECT CONTACTS</p>
                  <div onClick={()=>{
                    close()
                    }} style={{ cursor: "pointer" }}>
                    <IoIosClose size={35} color={"#808080"} />
                  </div>
                </div>
                {/* <TemplateSearch /> */}
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                  overflow: "scroll",
                  padding: "1rem 0px 1rem 1rem",
                  gap: "1rem",
                  marginBottom: "4rem",
                  marginRight: "10px",
                }}
              >
                <div className={styles.dropdownContainer}>
                  <span className={styles.selectTemplateTitle}>
                    Contact added date
                  </span>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: "0.5rem",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <p style={{ marginBottom: "0.25rem" }}>From:</p>
                      <div className={styles.dateInput}>
                        <input
                          type="date"
                          value={selectedFromDate}
                          onChange={(e) =>
                            setSelectedFromDate(e.target.value)
                          }
                          style={{
                            border: "none",
                            outline: "none",
                            width: "100%",
                            fontSize: "1rem",
                          }}
                        />
                      </div>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <p style={{ marginBottom: "0.25rem" }}>To:</p>
                      <div className={styles.dateInput}>
                        <input
                          type="date"
                          value={selectedToDate}
                          onChange={(e) =>setSelectedToDate(e.target.value)
                          }
                          style={{
                            border: "none",
                            outline: "none",
                            width: "100%",
                            fontSize: "1rem",
                          }}
                          disabled={
                            selectedFromDate === "" ? true : false
                          }
                          min={
                            selectedFromDate
                              ? selectedFromDate
                              : ""
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={styles.dropdownContainer}>
                  <span className={styles.selectTemplateTitle}>
                    Property Details
                  </span>
                  <Dropdown
                    isMulti
                    option={projectDropdownName}
                    selectedValue={selectedProjectName}
                    setSelectedValue={(value) => {
                      setSelectedProjectName(value);
                    }}
                    placeholder="Project name"
                  />
                  <Dropdown
                    isMulti
                    option={propertyTypeDropdown}
                    selectedValue={selectedPropertyType}
                    setSelectedValue={(value) => {
                      setSelectedPropertyType(value);
                    }}
                    placeholder="Property Type"
                  />
                  <Dropdown
                    isMulti={false}
                    option={["RENTAL", "RESALE", "NEW PROJECT"]}
                    selectedValue={selectedRequirementType}
                    setSelectedValue={(value) => {
                      setSelectedRequirementType(value)
                      setBudgetToDropdown([]);
                      setSelectedBudgetTo([]);
                      setSelectedBudgetFrom([]);
                    }}
                    placeholder="Requirement Type"
                  />
                </div>
                <div className={styles.dropdownContainer}>
                  <span className={styles.selectTemplateTitle}>Budget</span>
                  <div style={{ display: "flex", gap: "0.5rem" }}>
                    <Select
                      className={styles.select}
                      menuPlacement="auto"
                      maxMenuHeight={150}
                      options={[{ value: "0", label: "Min" }, ...BudgetRange]}
                      value={selectedBudgetFrom}
                      components={animatedComponents}
                      onChange={(data) => {
                        setBudgetToDropdown([]);
                        setSelectedBudgetFrom(data)
                        setSelectedBudgetTo([]);
                      }}
                      showCheckbox={true}
                      isSearchable={true}
                      isDisabled={false}
                      isMulti={false}
                      placeholder={"From"}
                    />
                    <Select
                      className={styles.select}
                      menuPlacement="auto"
                      maxMenuHeight={150}
                      options={
                        selectedBudgetFrom?.length === 0
                          ? selectedRequirementType?.label === "RENTAL"?[{ value: "5100000", label: "Max" }, ...BudgetRange]:[{ value: "1000000000", label: "Max" }, ...BudgetRange]
                          : selectedBudgetFrom[0]?.label ===
                              "Min" ||
                              selectedBudgetFrom[0]?.label ===
                              "Upto"
                          ? selectedRequirementType?.label === "RENTAL"?[{ value: "5100000", label: "Max" }, ...BudgetRange]:[{ value: "1000000000", label: "Max" }, ...BudgetRange]
                          : budgetToDropdown
                      }
                      value={selectedBudgetTo}
                      components={animatedComponents}
                      onChange={(data) => {
                        setSelectedBudgetTo(data)
                        if (
                          selectedBudgetFrom?.length === 0
                        ) {
                          setSelectedBudgetFrom({ value: "0", label: "Upto" })
                        }
                      }}
                      showCheckbox={true}
                      isSearchable={true}
                      isDisabled={false}
                      isMulti={false}
                      placeholder={"To"}
                    />
                  </div>
                </div>
                <div className={styles.dropdownContainer}>
                  <span className={styles.selectTemplateTitle}>
                    Lead Detail
                  </span>
                  <Dropdown
                    isMulti
                    option={leadSourceDropdown}
                    selectedValue={selectedLeadSource}
                    setSelectedValue={(value) => {
                      setSelectedLeadSource(value);
                    }}
                    placeholder="Lead Source"
                  />
                  <Dropdown
                    isMulti
                    option={leadTypeDropdown}
                    selectedValue={selectedLeadType}
                    setSelectedValue={(value) => {
                      setSelectedLeadType(value);
                    }}
                    placeholder="Lead Type"
                  />
                  <Dropdown
                    isMulti
                    option={leadAssigneDropdown}
                    selectedValue={selectedLeadAssignee}
                    setSelectedValue={(value) => {
                      setSelectedLeadAssignee(value);
                    }}
                    placeholder="Lead Assignee"
                  />
                </div>
              </div>
              <div className={styles.buttonsContainer}>
                <CustomButton
                  text="Cancel"
                  onClick={() => {
                    close();
                  }}
                  buttonType="secondary"
                />
                <CustomButton
                  text="Add Contacts"
                  onClick={onSubmit}
                  buttonType="primary"
                />
              </div>
            </motion.div>
          </Backdrop>
        )}
      </AnimatePresence>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    theme: state.theme.isLightMode,
    user: state.user.data,
    analyticsFilter: state.analyticsFilter,
    browseContactData: state.browseContactData,
  };
};

export default connect(mapStateToProps)(BrowseContacts);
